import { useState } from "react";
import { Link, Redirect } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import { login } from "../_redux/authCrud";

/*
  INTL (i18n) docs:
  https://github.com/formatjs/react-intl/blob/master/docs/Components.md#formattedmessage
*/

/*
  Formik+YUP:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
*/

const initialValues = {
  username: "",
  password: ""
};

function Login(props) {
  const { intl } = props;
  const { authData } = props;
  const [isOtpRequired, setIsOtpRequired] = useState(false);
  const [loading, setLoading] = useState(false);
  const LoginSchema = Yup.object().shape({
    username: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required(
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD",
        })
      ),
    password: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required(
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD",
        })
      ),
  });

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: LoginSchema,
    onSubmit: (values, { setValues, setStatus, setSubmitting }) => {
      const loginData = {
        domain: authData.domain,
        authId: authData.authId,
        username: values.username,
        password: values.password,
        token: props.token
      };
      setLoading(true);
      setTimeout(async () => {
        login(loginData)
        .then(({ data: {
          isSuccess,
          type,
          message,
          isOtpRequired,
          authToken,
          currentUser
        }}) => {
          if (isOtpRequired) {
            setIsOtpRequired(true);
            props.setUserInfo(authData.authId, currentUser.phoneFourChar);
          }

          if (type === "error") type = "danger"; 
          setValues(type);
          setStatus(message);
          if (isSuccess) props.login(currentUser, authToken);
        })
        .catch(() => {
          setValues("danger");
          setStatus(
            "İşlem Sırasında Bir Hata Oluştu. Lütfen Sistem Yöneticiniz İle İrtibata Geçiniz!"
              // intl.formatMessage({
              //   id: "AUTH.VALIDATION.INVALID_LOGIN",
              // })
          );
        })
        .finally(() => {
          setLoading(false);
          setSubmitting(false);
        });
      }, 1000);
    },
  });

  return (
    <>
      {isOtpRequired && <Redirect to="/otp-dogrulama" />}
      {!isOtpRequired &&
        <div className="login-form login-signin" id="kt_login_signin_form">
          {/* begin::Head */}
          <div className="text-center mb-10 mb-lg-20">
            <h3 className="font-size-h1">
              {authData.schoolName}
            </h3>
          </div>
          {/* end::Head */}

          {/*begin::Form*/}
          <form
            onSubmit={formik.handleSubmit}
            className="form fv-plugins-bootstrap fv-plugins-framework"
          >
            {formik.status ? (
              <div className={`mb-10 alert alert-custom alert-light-${formik.values} alert-dismissible`}>
                <div className="alert-text font-weight-bold">
                  {formik.status}
                </div>
              </div>
            ) : (
              <div className="mb-10 alert alert-custom alert-light-info alert-dismissible">
                <div className="alert-text ">
                  Giriş yapmak için <strong>kullanıcı adı</strong> ve <strong>şifrenizi</strong> giriniz.
                </div>
              </div>
            )}       

            <div className="form-group fv-plugins-icon-container">
              <input
                placeholder="Kullanıcı Adı"
                type="text"
                className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                  "username"
                )}`}
                name="username"
                {...formik.getFieldProps("username")}
              />
              {formik.touched.username && formik.errors.username ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.username}</div>
                </div>
              ) : null}
            </div>
            <div className="form-group fv-plugins-icon-container">
              <input
                placeholder="Şifre"
                type="password"
                className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                  "password"
                )}`}
                name="password"
                {...formik.getFieldProps("password")}
              />
              {formik.touched.password && formik.errors.password ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.password}</div>
                </div>
              ) : null}
            </div>
            <div className="form-group d-flex flex-wrap justify-content-between align-items-center">
              <Link
                to="/sifremi-unuttum"
                className="text-dark-50 text-hover-primary my-3 mr-2"
                id="kt_login_forgot"
              >
                Şifremi Unuttum
                {/* <FormattedMessage id="AUTH.GENERAL.FORGOT_BUTTON" /> */}
              </Link>
              <button
                id="kt_login_signin_submit"
                type="submit"
                disabled={formik.isSubmitting}
                className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
              >
                {!loading && <span>Giriş Yap</span>}
                {
                  loading &&
                  <>
                    <span>Giriş Yapılıyor</span>
                    <span className="ml-3 spinner spinner-white"></span>
                  </>
                }
              </button>
            </div>
          </form>
          {/*end::Form*/}   
        </div>
      }
    </>
  );
}

export default injectIntl(connect(({ auth }) => ({ token: auth.token }), auth.actions)(Login));